<template>
    <Reviews />
</template>
<script>
import Reviews from '@/components/Reviews.vue';

export default {
    name: 'ReviewsAdd',
    components: {
        Reviews
    },
}
</script>
